import React from 'react'
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import { makeStyles } from '@material-ui/core/styles';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import GroupWorkIcon from '@material-ui/icons/GroupWork';
import {Home} from "@material-ui/icons/";
const useStyles = makeStyles(theme =>({
    root: {
      justifyContent:'center',
      alignItem:'center',
      width: 500,
     marginBottom:40
    },
    fonctionAction:{
        marginBottom:20
    },
    btnAction:{
      width:80,
      height:80,
      backgroundColor:'#fff',
      color:theme.palette.primary.main,
      '&:hover':{
        backgroundColor:theme.palette.primary.main,
        color:theme.palette.primary.contrastText
      },
      '&active':{
        backgroundColor:theme.palette.primary.main,
        color:theme.palette.primary.contrastText
      }
    },
    
  }));


function HeaderFonction(props) {
  const {handleFonctionMini} = props
    const classes = useStyles()
    const [currentV, setCurrentV] = React.useState('recents')
    const handleChange = (event,newValue) => {  
        setCurrentV(newValue);
        handleFonctionMini(newValue)
    }

    return (
       
        <BottomNavigation  value={currentV} component='div' onChange={handleChange} className={classes.root}>
            <BottomNavigationAction showLabel className={classes.btnAction}  label="Home" value="HOME" icon={<Home />} />
            <BottomNavigationAction showLabel className={classes.btnAction}  label="Utilisateurs" value="USER" icon={<PeopleAltIcon />} />
            <BottomNavigationAction showLabel className={classes.btnAction} label="Agences" value="AGENCE" icon={<GroupWorkIcon />} />
            <BottomNavigationAction showLabel className={classes.btnAction} label="Zones" value="ZONE" icon={<BusinessCenterIcon />} />
        </BottomNavigation> 
         
    )
}

HeaderFonction.propTypes = {

}

export default HeaderFonction

